var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.286 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.286C0,6.406,6.406,0,14.286,0h85.714c7.879,0,14.286,6.406,14.286,14.286v71.429c0,7.879-6.406,14.286-14.286,14.286H14.286c-7.879,0-14.286-6.406-14.286-14.286V14.286ZM72.277,38.058c-1.004-1.473-2.656-2.344-4.42-2.344s-3.437.871-4.42,2.344l-19.42,28.482-5.915-7.388c-1.027-1.272-2.567-2.009-4.174-2.009s-3.17.737-4.174,2.009l-14.286,17.857c-1.295,1.607-1.54,3.817-.647,5.67s2.768,3.036,4.821,3.036h75c1.987,0,3.817-1.094,4.732-2.857s.804-3.884-.312-5.513l-26.786-39.286h0ZM25,35.714c5.917,0,10.714-4.797,10.714-10.714s-4.797-10.714-10.714-10.714-10.714,4.797-10.714,10.714,4.797,10.714,10.714,10.714Z",
    fill: "#a1a1b3",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconplaceholder);
export default __webpack_public_path__ + "static/media/icon.placeholder.b6c5a89f3dc05c8a79f0dab009999728.svg";
export { ForwardRef as ReactComponent };